import * as notifications from '../xhr/notifications.js';
import * as types from './types/notifications.js';
import * as userTypes from './types/users.js';
import * as advisorTypes from './types/advisors.js';
import * as accountTypes from './types/accounts.js';
import * as notifier from './notifier.js';
import * as loader from './loader.js';

/**
 * @param dispatch
 * @param isLoading
 * @param type
 */
function setLoader(dispatch, isLoading, type = 'full') {
    dispatch(loader.setLoader({
        isLoading,
        type
    }));
}

/**
 * @returns {function(*=): Promise<T | never>}
 */
export function getNotifications(type, id = 'none') {
    return (dispatch) => {
        setLoader(dispatch, true);

        return notifications
            .get(type, id)
            .then((data) => {
                dispatch({
                    type: types.GET_NOTIFICATIONS_SUCCESS,
                    notifications: data
                });

                setLoader(dispatch, false);
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}

/**
 * @param id
 * @param type
 * @returns {function(*=): Promise<any | never>}
 */
export function removeNotification(id, type = 'internal') {
    return (dispatch) => {
        setLoader(dispatch, true);

        return notifications
            .remove(id)
            .then(() => {
                if (type === 'internal') {
                    dispatch({
                        type: types.REMOVE_NOTIFICATION_SUCCESS,
                        id
                    });
                } else if (type === 'user') {
                    dispatch({
                        type: userTypes.REMOVE_NOTIFICATION_SUCCESS,
                        id
                    });
                } else if (type === 'advisor') {
                    dispatch({
                        type: advisorTypes.REMOVE_NOTIFICATION_SUCCESS,
                        id
                    });
                } else if (type === 'account') {
                    dispatch({
                        type: accountTypes.REMOVE_NOTIFICATION_SUCCESS,
                        id
                    });
                }

                setLoader(dispatch, false);
                return true;
            })
            .catch((error) => {
                setLoader(dispatch, false);
                dispatch(notifier.displayError(error));
            });
    };
}